import React from 'react';
import { Link } from 'react-router-dom';
import { Mic, ArrowRight } from 'lucide-react';

/**
 * Home CTA card for the anonymous voicemail line. Tells readers the
 * option exists (a lot of people won't type but will talk) and routes to
 * `/voicemail` where the recorder lives. Styled as a dark card with a
 * pulsing red mic so it reads as "record now".
 */
const HomeVoicemailCard = () => (
  <section className="max-w-4xl mx-auto px-4 pb-6" data-testid="home-voicemail-card">
    <Link
      to="/voicemail"
      className="group relative block overflow-hidden rounded-lg border border-red-900/50 bg-gradient-to-br from-red-950/40 via-black to-zinc-950 p-5 sm:p-6 hover:border-red-500 transition-colors"
      data-testid="home-voicemail-link"
    >
      <span aria-hidden className="pointer-events-none absolute -top-16 -right-16 h-40 w-40 rounded-full bg-red-600/25 blur-3xl" />
      <div className="relative flex items-center gap-4 sm:gap-5">
        <span className="relative shrink-0 h-14 w-14 sm:h-16 sm:w-16 rounded-full bg-red-600 text-white flex items-center justify-center shadow-[0_0_24px_rgba(220,38,38,0.55)]">
          <span aria-hidden className="absolute inset-0 rounded-full bg-red-500/40 animate-ping" />
          <Mic className="relative h-6 w-6 sm:h-7 sm:w-7" />
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-red-400 text-[10px] font-black uppercase tracking-[0.35em] mb-1">Voicemail line · Winamp</p>
          <h3 className="text-white text-lg sm:text-xl font-black leading-tight" style={{ fontFamily: 'Georgia, serif' }}>
            Leave Ryan an anonymous voicemail.
          </h3>
          <p className="text-zinc-400 text-xs sm:text-sm mt-1">
            Tap, talk, done. Up to 5 minutes. Nothing about you is logged.
          </p>
        </div>
        <ArrowRight className="hidden sm:block h-5 w-5 text-red-400 group-hover:translate-x-1 transition-transform shrink-0" />
      </div>
    </Link>
  </section>
);

export default HomeVoicemailCard;
